export const visitTypeFromJson = (json) => {
  return {
    defaultPrice: json.default_price,
    key: json.key,
    symptoms: json.symptoms,
    uuid: json.uuid,
    label: json.name,
  };
};
